module.exports = __webpack_public_path__ + "img/sixpackcarrier12.0c857da2.jpg";